import { crestHarmonics, type RankStatus } from "../engine/rank";

type CrestProps = { status: RankStatus; seed: number; size?: number };

/** Generated rank mark: a sum of sines whose harmonic count equals the rank
    tier (+ prestige stars). Rank 1 is nearly flat; higher ranks are denser,
    richer waveforms — progression is literally your voice getting richer.
    Deterministic from (rank, seed), so it's stable across renders. */
export function Crest({ status, seed, size = 32 }: CrestProps) {
  const harmonics = crestHarmonics(status);
  const width = size * 3;
  const height = size;
  const points = 48;
  const coords = Array.from({ length: points }, (_, i) => {
    const t = i / (points - 1);
    let y = 0;
    for (let h = 1; h <= harmonics; h++) {
      const phase = (seed * 0.014 * h) % (Math.PI * 2);
      y += Math.sin(t * Math.PI * 2 * h + phase) / h;
    }
    y = y / Math.max(1, Math.log2(harmonics + 1));
    return `${(t * width).toFixed(1)},${(height / 2 + y * (height / 2 - 2)).toFixed(1)}`;
  });

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} class="crest" aria-hidden="true">
      <path
        d={`M ${coords.join(" L ")}`}
        fill="none"
        stroke="var(--accent)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
